module.exports = __webpack_public_path__ + "static/img/14.7cc493a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/clientes/14.png
// module id = fXup
// module chunks = 0